/**
 * Component for rendering a single message in the tutor conversation
 * Styled to match the MessageItem component
 */
import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import theme from "@shared/utils/themeColors";
import { TutorMessage as TutorMessageType } from "../types";

interface TutorMessageProps {
  message: TutorMessageType;
}

const TutorMessage: React.FC<TutorMessageProps> = ({ message }) => {
  const isUser = message.role === "user";

  return (
    <div
      className={`flex items-start mb-4 ${isUser ? "justify-end" : "justify-start"} last:mb-0 mb-4 group`}
    >
      <div className="max-w-[75%]">
        <div
          className={`relative p-3 rounded-lg ${isUser
            ? `${theme.bg.brand} ${theme.text.black} rounded-br-none`
            : "bg-gray-200 dark:bg-gray-800 text-gray-800 dark:text-gray-100 rounded-bl-none"
            }`}
        >
          {isUser ? (
            <p className="whitespace-pre-wrap">{message.content}</p>
          ) : (
            <div className="prose prose-sm sm:prose max-w-none markdown-content dark:prose-invert">
              <ReactMarkdown
                remarkPlugins={[remarkGfm]}
                components={{
                  // Add responsive table support
                  table: ({ node, ...props }) => (
                    <div className="overflow-x-auto">
                      <table {...props} className="min-w-full" />
                    </div>
                  ),
                }}
              >
                {message.content}
              </ReactMarkdown>
            </div>
          )}
        </div>
        <div className="flex items-center justify-between">
          <div className={`text-xs ${theme.text.muted}`}>
            {new Date(message.timestamp || message.createdAt).toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TutorMessage;
